import React,{useState,useEffect} from 'react'
import {Route, Switch, useRouteMatch} from "react-router-dom"
import { url } from '../../App';
import {BoxSkill,Img,Title,Description,ReadMore, SectionSKill} from '../../globalStyle'
import { BorderBottom, TitleSection, Wrapps, WrappSkill,WrappSkillDetail } from '../../globalStyle';
import ImageError from '../error/error';
import Skeleton from '../skeleton/skeleton';
import DetailSkill from './detail';


 function SkillAllApp(){
    const [ data, setData ] = useState([]);
    const [loading, setLoading] = useState(false)
    const [error,setError] = useState(false)
    useEffect(() => {
        const getAllSkill = async() => {
            setLoading(true)
            try{
                let res = await fetch(`${url}/skill`)
                let data = await res.json()
                setData(data.data)
            }catch(error){
                setError(true)
            }finally{
                setLoading(false)
            }
        }
        getAllSkill()
        return()=>{
            setData('')
        }
    },[])
    
   if(error){
       return(
            <ImageError />
        )
   }
  
    return(
        <>
     
        <WrappSkillDetail>
            <TitleSection margin>All-Skill</TitleSection>
            <BorderBottom />
            <Wrapps>
                {
                    loading ? (<Skeleton width={"250px"} height={"320px"} amount={4} />) : (
                        data.map((item,index)=>{
                            return(
                            <BoxSkill key={index}>
                                <Img src={item.image} alt="Skill" />
                                <Title>{item.nama.substr(0,40) + '...'}</Title>
                                <Description>{item.body.substr(0,40) + '...'}</Description>
                                <ReadMore to={'skills/'+ item.id}> read more</ReadMore>
                            </BoxSkill>
                            )
                        })
                    )
                }
            </Wrapps>
        </WrappSkillDetail>
           
        </>
    )

}

export default SkillAllApp;